import React from 'react';
import { CTAButton } from './CTAButton';
import { HeartIcon } from 'lucide-react';
export function ValueSection() {
  const truths = ['Tu hijo no rechaza el español: rechaza la vergüenza asociada a él.', 'El español que no usen hoy… difícilmente vuelve mañana.', 'Tus abuelos merecen escuchar a tus hijos en español.', 'Una casa bilingüe es una casa con dos corazones.', 'Aún estás a tiempo.', 'Esto no es culpa tuya. Pero sí está en tus manos cambiarlo.'];
  const reallyBuying = ['la conexión de tus hijos con sus abuelos', 'el orgullo bilingüe que llevarán toda la vida', 'momentos familiares que se vuelven tesoros', 'un idioma que merece vivir en tu casa', 'un legado que no quieres que se pierda'];
  return <section className="py-16 px-4 bg-white" data-id="element-152">
      <div className="max-w-5xl mx-auto" data-id="element-153">
        <div className="mb-16" data-id="element-154">
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12" data-id="element-155">
            VERDADES QUE NECESITABAS ESCUCHAR
          </h2>

          <div className="grid md:grid-cols-2 gap-6" data-id="element-156">
            {truths.map((truth, index) => <div key={index} className="bg-amber-50 p-6 rounded-lg border-l-4 border-amber-500" data-id="element-157">
                <p className="text-lg text-gray-800 font-medium" data-id="element-158">{truth}</p>
              </div>)}
          </div>
        </div>

        <div className="bg-gradient-to-br from-rose-50 to-orange-50 p-8 md:p-12 rounded-2xl shadow-xl" data-id="element-159">
          <div className="flex items-center justify-center gap-3 mb-8" data-id="element-160">
            <HeartIcon className="text-rose-500" size={32} data-id="element-161" />
            <h2 className="font-serif text-3xl md:text-4xl font-bold text-center text-gray-900" data-id="element-162">
              LO QUE REALMENTE ESTÁS COMPRANDO
            </h2>
            <HeartIcon className="text-rose-500" size={32} data-id="element-163" />
          </div>

          <p className="text-xl text-center text-gray-700 mb-8" data-id="element-164">
            No estás comprando un libro.
          </p>

          <p className="text-2xl font-bold text-center text-gray-900 mb-8" data-id="element-165">
            Estás comprando:
          </p>

          <div className="space-y-4 mb-8" data-id="element-166">
            {reallyBuying.map((item, index) => <div key={index} className="flex items-start gap-3 bg-white p-4 rounded-lg" data-id="element-167">
                <HeartIcon className="text-rose-500 flex-shrink-0 mt-1" size={24} data-id="element-168" />
                <span className="text-lg text-gray-800" data-id="element-169">{item}</span>
              </div>)}
          </div>

          <div className="text-center" data-id="element-170">
            <p className="text-xl text-gray-800 mb-6 italic" data-id="element-171">
              El español no es una materia. Es un puente emocional. Y aún estás
              a tiempo de reforzarlo.
            </p>
            <CTAButton size="large" data-id="element-172">Empieza Hoy</CTAButton>
          </div>
        </div>
      </div>
    </section>;
}